import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  modalHeaderCustom: {
    border: "none",
    "& button": {
      padding: "14px",
      "&:hover": {
        backgroundColor: colors.brightBlue
      }
    },
    "& .btn-close": {
      "&:focus-visible":{
        boxShadow: "0px 0px 0px 4px " + colors.primary500Blue
      },
    }
  },
  iconWrapper: {
    border: theme.icon.border,
    borderRadius: theme.icon.borderRadius,
    boxShadow: theme.icon.boxShadow,
    backgroundColor: theme.icon.backgroundColor,
    height: "48px",
    width: "48px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    "& svg": {
      "& path": {
        stroke: theme.icon.stroke
      }
    }
  },
  titleWrapper: {
    color: colors.lightBlack,
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "18px",
  },
  subtitleWrapper: {
    color: colors.mediumGrey,
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    display: "flex",
  },
  title: {
    padding: "0 0 0 16px",
    color: colors.lightBlack,
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "18px",
  },
  description: {
    color: colors.mediumGrey,
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
  },
  modalFooter: {
    border: "none"
  },
  body: {
    color: colors.mediumGrey
  },
}));

export default styles;
